import e from "./truncateElement.js";
var t = function t(_t4, l, i, n) {
  var o;
  if (!window && !document) return;
  var d = null === (o = document.getElementById("inner-".concat(_t4))) || void 0 === o ? void 0 : o.clientHeight;
  var g = parseInt(l().match(/\d+/)[0], 10) || 0;
  var c = document.getElementById("tilelet-title-".concat(_t4)),
    m = document.getElementById("tilelet-badge-".concat(_t4)),
    r = document.getElementById("tilelet-eyebrow-".concat(_t4)),
    a = document.getElementById("tilelet-icon-container-".concat(_t4)),
    h = document.getElementById("tilelet-subtitle-".concat(_t4)),
    p = document.getElementById("tilelet-eyebrow-".concat(_t4, "-wrapper")),
    u = document.getElementById("tilelet-title-".concat(_t4, "-wrapper"));
  m && (g += 4), r && p && (g += p && parseFloat(window.getComputedStyle(p).getPropertyValue("padding-bottom"))), c && u && (g += u && parseFloat(window.getComputedStyle(u).getPropertyValue("margin-bottom")));
  var y = d ? d - g : 0;
  if (r && r.clientHeight && (y -= r.clientHeight), a && a.clientHeight && (y -= a.clientHeight), c && c.clientHeight) {
    var _t = c.clientHeight;
    y > _t || (i && !i.tooltip && e(c, y), _t = c.clientHeight), y -= _t;
  }
  if (m && m.clientHeight) {
    var _t2 = m.clientHeight;
    y > _t2 ? y -= _t2 : y > parseFloat(window.getComputedStyle(m).lineHeight) ? (e(m, y), _t2 = m.clientHeight, y -= _t2) : e(m, 0);
  }
  if (h && h.clientHeight) {
    h.style.height = "";
    var _t3 = h.clientHeight;
    y > _t3 ? y -= _t3 : y > parseFloat(window.getComputedStyle(h).lineHeight) ? n && !n.tooltip && e(h, y) : (h.style.height = "1px", h.style.overflow = "hidden");
  }
};
export { t as default };